export const getCookieValue = (name) => {
  const { cookie } = document;
  const cookies = cookie.replace(/\s/g, "").split(";");
  let value = "";

  for (let i = 0; i < cookies.length; i++) {
    if (cookies[i].indexOf(`${name}=`) !== -1) {
      value = cookies[i].replace(`${name}=`, "");
    }
  }

  return value;
};

export const setCookie = (cname, cvalue, exdays = 400) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
